export default __webpack_public_path__ + "fc14cf0163fa1c13c61a2bb0091de8ca.png";